import StudentsTable from "views/admin/tables/components/StudentsTable";
import { useAppLanguage } from "hooks/useAppLanguage";
import { MdPeople } from "react-icons/md";

export default function StudentsPage() {
  const isArabic = useAppLanguage() === "ar";

  return (
    <div dir={isArabic ? "rtl" : "ltr"}>
      <div className="mb-5 flex items-center gap-3">
        <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-emerald-500/10 text-emerald-500 dark:bg-emerald-400/10 dark:text-emerald-300">
          <MdPeople className="h-6 w-6" />
        </span>
        <div>
          <h1 className="text-2xl font-extrabold text-navy-700 dark:text-white">
            {isArabic ? "إدارة الطلاب" : "Student management"}
          </h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-slate-400">
            {isArabic
              ? "إضافة الطلاب ومتابعة حساباتهم وحالتهم الأكاديمية."
              : "Create students and manage their accounts and academic status."}
          </p>
        </div>
      </div>
      <StudentsTable />
    </div>
  );
}
